import qs from 'qs';


type Query = { [key: string]: string };

const updateStringWithQueryParams = (inputString = '', query: Query = {}): string => {
  if (inputString === null) {
    // return original data when the input is null
    return inputString;
  }

  const [beforeBaseStr, afterBaseSrt] = String(inputString).split('?');

  const before = String(beforeBaseStr || '').trim();

  // parse current query to object ?key=value -> {key:value}
  const currentQuery = qs.parse(
    String(afterBaseSrt || '')
      .trim()
      // clean invalid start/end
      .split('&')
      .filter(Boolean)
      .join('&')
  );

  // merge current query + custom query
  const queryString = qs
    .stringify({
      ...currentQuery,
      ...query,
    })
    .trim();

  if (queryString) {
    return `${before}?${queryString}`.trim();
  }

  // when no query params at all just return input
  return inputString;
};

export default updateStringWithQueryParams;
